module.exports = __webpack_public_path__ + "static/media/cataclysm.9f6c2acb.mp3";